module.exports = __webpack_public_path__ + "img/3-up.915e9a2b.png";